import { BaseBlockProps } from '../../defs/block';

export type LaserBoxBlockID = 'laserBoxHorizontal' | 'laserBoxVertical';

export type LaserBoxBlockType = 'laserBox';

export type LaserBoxBlockProps = {
  type: LaserBoxBlockType;
} & BaseBlockProps;

export const laserBoxBlockProps: Record<LaserBoxBlockID, LaserBoxBlockProps> = {
  laserBoxHorizontal: {
    id: 'lbh',
    type: 'laserBox',
    options: [{ count: 4 }, { count: 3 }, { count: 2 }, { count: 1 }],
    optionType: 'list',
    noEditorOptions: true,
  },
  laserBoxVertical: {
    id: 'lbv',
    type: 'laserBox',
    options: [{ count: 4 }, { count: 3 }, { count: 2 }, { count: 1 }],
    optionType: 'list',
    noEditorOptions: true,
  },
};
